<template>
  <div class="group-page">
    <solution-banner :dataSouce="banner" />
    <div class="section">
      <div class="section-box bg-w">
        <div class="section-con">
          <h3 class="title">数字化营销转型面临的挑战</h3>
          <p class="subtitle">
            客户规模下降、获客成本上升，失去营销主动权
          </p>
          <solution-card :dataSouce="card" />
        </div>
      </div>
      <div class="section-box bg-b">
        <div class="section-con">
          <h3 class="title">通过大自渠体系完成收客动作，向案场输入精准客户</h3>
          <solution-panel :dataSouce="panel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SolutionBanner from "./components/Banner.vue";
import SolutionCard from "./components/Card.vue";
import SolutionPanel from "./components/Panel.vue";
export default {
  name: "SolutionCity",
  components: {
    SolutionBanner,
    SolutionCard,
    SolutionPanel,
  },
  data() {
    return {
      banner: [
        {
          image: "https://cdn.ideamake.cn/sw-pc/images/banner/banner-group-03.png",
          title: "深耕城市，打造城市级标杆",
          link: "/index",
        },
      ],
      card: [
        {
          title: "单盘效率低",
          list: [
            "客户无法复用，城市新项目上线需重新积累客",
            "线上投放广撒网，引流效果差，客户规模下降",
          ],
          
        },
        {
          title: "案场转化差",
          list: [
            "专人跟进维系弱，客户成交周期长，难转化",
            "客户画像不清晰，输送到案场的客源不精准",
          ],
         
        },
        {
          title: "营销成本高",
          list: [
            "分销、高佣金渠道占比高，成交结构失衡",
            "线上流量贵，单客成本高",
          ],
          
        },
      ],
      panel: [
        {
          direction: "left",
          title: "城市中台",
          subtitle:
            "基于城市中台构建小前端大中台模式",
          link: "/index",
          list: [
            "告别城市各项目割裂式单兵作战，资源统一集中到城市中台，打造轻量级案场，通过中台对前端的赋能实现资源最优配置和多元的增长路径",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-04.png",
        },
        {
          direction: "right",
          title: "通盘通客",
          subtitle: "规模化的客户获取、客户运营、客户转化",
          link: "/index",
          list: [
            "通盘通客，通过统一投放引流实现全渠道规模化获客，提供完整清晰客户运营和转化路径，最大化挖掘客户价值",
          ],
          image: "https://cdn.ideamake.cn/sw-pc/images/solution-05.png",
        },
        
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.group-page {
  width: 100%;
  height: 100%;
  .section {
    width: 100%;
    height: 100%;
    
   
    &-box {
      width: 100%;
      height: 100%;
      padding: 80px 0;
      &.bg-w{
        background: #F7F9FB;
      }
      &.bg-b{
        background: #FFF;
      }
      .section-con {
        width: 1200px;
        margin: 0 auto;
        text-align: center;
      }
      .title {
        font-size: 32px;
        font-weight: 500;
        color: #2d2e30;
        padding-bottom: 20px;
      }
      .subtitle {
        font-size: 16px;
        font-weight: 400;
        padding-bottom: 60px;
        color: #5a5c60;
      }
    }
  }
}

// 移动端布局
@import "@/views/solution/min-solution";
</style>